import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Col, FormFeedback, FormGroup, Label } from 'reactstrap';
import classnames from 'classnames';
import moment from 'moment';

import BrzwDatePicker from '../../../brzw_date_picker';

class FormControlDatePicker extends Component {
  constructor(props) {
    super(props);

    this.onDateChange = this.onDateChange.bind(this);
  }

  onDateChange(pickedDate) {
    const { input } = this.props;

    if (!pickedDate) {
      input.onChange(null);
    } else {
      const formattedDate = pickedDate.format('YYYY-MM-DD');

      input.onChange(formattedDate);
    }
  }

  render() {
    const {
      className,
      classNameContainer,
      futureOnly,
      id,
      input,
      isClearable,
      label,
      meta,
      required,
    } = this.props;

    let dateErrorText = null;
    let validationState = null;
    if (meta.touched) {
      if (meta.error) {
        dateErrorText = meta.error;
        validationState = 'danger';
      } else {
        validationState = 'success';
      }
    }

    let selected;
    if (input.value) {
      selected = moment(input.value);
    }

    return (
      <FormGroup row className={classnames('form-group-row', classNameContainer)}>
        <div className="form-group-row__label-container">
          <Label
            for={`${id}-date`}
            className="form-group-row__label form-group-row__label-with-checkbox"
          >
            {required ? (
              <span>
                {label} <span className="text-orange">*</span>
              </span>
            ) : (
              label
            )}
          </Label>
        </div>

        <Col className="form-group-row__col">
          <BrzwDatePicker
            dateFormat="MMM D, YYYY"
            futureOnly={futureOnly}
            inputClassName={classnames(
              'form-control form-group-row__input',
              className,
              validationState,
            )}
            isClearable={isClearable}
            onChange={this.onDateChange}
            selected={selected}
          />
          <FormFeedback>{dateErrorText}</FormFeedback>
        </Col>
      </FormGroup>
    );
  }
}

FormControlDatePicker.propTypes = {
  className: PropTypes.string,
  classNameContainer: PropTypes.string,
  futureOnly: PropTypes.bool,
  id: PropTypes.string,
  input: PropTypes.shape({
    value: PropTypes.string,
  }),
  isClearable: PropTypes.bool,
  label: PropTypes.string,
  meta: PropTypes.shape({}),
  required: PropTypes.bool,
};

FormControlDatePicker.defaultProps = {
  futureOnly: false,
  isClearable: false,
  required: false,
};

export default FormControlDatePicker;
